import { render, staticRenderFns } from "./GoToPoll.vue?vue&type=template&id=928eef42&scoped=true&"
import script from "./GoToPoll.vue?vue&type=script&lang=js&"
export * from "./GoToPoll.vue?vue&type=script&lang=js&"
import style0 from "./GoToPoll.vue?vue&type=style&index=0&id=928eef42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928eef42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('928eef42')) {
      api.createRecord('928eef42', component.options)
    } else {
      api.reload('928eef42', component.options)
    }
    module.hot.accept("./GoToPoll.vue?vue&type=template&id=928eef42&scoped=true&", function () {
      api.rerender('928eef42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/GoToPoll.vue"
export default component.exports